/**
 * Notifications service (client-side) — VP Feedback Loop (AC-vpfb-7/8/9/11)
 *
 * Wraps the /api/v1/notifications endpoints.
 */

import { fetchJson, mutate } from './base-roros.service';

export interface RorosNotificationDTO {
  id: string;
  orgId: string;
  recipientUserId: string;
  type: string;
  title: string;
  body: string;
  linkType: string | null;
  linkId: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsListResult {
  items: RorosNotificationDTO[];
  unreadCount: number;
}

export const notificationsService = {
  /** List current user's notifications for the current org. */
  list(): Promise<NotificationsListResult> {
    return fetchJson<NotificationsListResult>('/api/v1/notifications');
  },

  /** Mark a single notification as read. */
  markRead(id: string): Promise<void> {
    return mutate<void>(`/api/v1/notifications/${id}/read`, 'POST');
  },

  /** Mark all notifications as read. */
  markAllRead(): Promise<void> {
    return mutate<void>('/api/v1/notifications/read-all', 'POST');
  },
};
